export const PinPickup = require('./pickup.png');
export const PinHome = require('./home.png');
export const PinWork = require('./work.png');
export const PinCustom = require('./custom.png');
export const PinOutpost = require('./outpost.png');
export const PinCourier = require('./courier.png');
export const PinCustomer = require('./customer.png');
export const PinLocation = require('./location.png');
export const PinPickupClosed = require('./pickup-closed.png');
export const PinOutpostClosed = require('./outpost-closed.png');
export const PinMinimizedClosed = require('./minimized-closed.png');
export const PinMinimizedOpen = require('./minimized-open.png');
